require('../scss/price-card.scss');
import { mapGetters } from 'vuex';
import Button from '../../shared/Button';
import ProductDetails from '../ProductDetails';
import Accounting from '../../../mixins/accounting';
import BookingsLang from '../../../lang/bookings';
import PriceCardLocalisations from '../../../lang/PriceCard';
import merge from 'lodash/merge';
import branding from '../../../mixins/branding';

export default {
    name: 'PriceCard',

    props: ['product', 'vehicle', 'buy', 'labels', 'selectedCurrency', 'selectVehicle', 'currencyIsChanging', 'showTermsAndConditions', 'user', 'handleLogin', 'experiment'],

    i18n: merge(BookingsLang, PriceCardLocalisations),

    components: {
        'gm-button': Button,
        ProductDetails,
    },

    computed: Object.assign(
        {
            vehiclePrice() {
                return this.quoteHireDuration > 1 ? this.originalPricePerDay(this.product, this.quoteHireDuration) : this.formatMoney(this.product.total_price, this.selectedCurrency.code);
            },
        },
        mapGetters({
            quoteHireDuration: 'quoteHireDuration',
        })
    ),

    mixins: [Accounting, branding],

    watch: {
        quoteHireDuration: function (duration) {
            this.vehiclePricePerDay = this.originalPricePerDay(this.product, duration);
        },
    },

    data() {
        return {
            icons: {
                PMP: this.brandingImagesPath('/images/vehicle-listing/drive-go.svg'),
            },
            productLabels: {
                PMP: 'premium plus+',
            },
            keylessLoginRequired: KEYLESS_LOGIN_REQUIRED !== 'false',
            vehiclePricePerDay: 0,
        };
    },

    template: `
    <div class="price-card">
        <div class="content-wrapper">
            <div class="top-content">
                <div>
                    <h5 class="title text-center"><img :src="icons[product.type]" alt=""></h5>
                    <p class="text-center">
                        <strong class="original-amount" v-if="product.original_price && !currencyIsChanging">{{ originalPrice(product) }}</strong>
                        <strong class="amount" v-if="currencyIsChanging">&hellip;</strong>
                        <strong class="amount" v-else>{{ vehiclePrice }}</strong>
                        <br/>
                        <span>{{ labels.extraPerDay }}</span>
                    </p>
                </div>
            </div>
            <div class="bottom-content">
                <product-details :product="product" :currency-is-changing="currencyIsChanging" :show-terms-and-conditions="showTermsAndConditions" :experiment="experiment"></product-details>
                <div class="desktop-choose-product" v-if="product.is_available">
                    <div v-if="keylessLoginRequired && !user && vehicle.is_drive_and_go" class="choose-product" :class="product.type" @click="handleLogin();">
                        {{ $t('bookings.login_register') }}
                        <img :src="brandingImagesPath('/images/large-arrow-white.svg')" alt="right arrow white" v-if="product.type == 'PMP'">
                        <img :src="brandingImagesPath('/images/large-arrow-green.svg')" alt="right arrow green" v-else>
                    </div>
                    <div v-if="!keylessLoginRequired || (user && vehicle.is_drive_and_go) || !vehicle.is_drive_and_go" class="choose-product" :class="product.type" @click="selectVehicle(vehicle, product.id);">
                        {{ $t('bookings.book_drive_go') }}
                    </div>
                </div>
                <gm-button
                    top-right-radius="0"
                    top-left-radius="0"
                    :disabled="true"
                    v-else
                >
                    {{ $t('PriceCard.minimum_age', { age: product.minimum_age }) }}
                </gm-button>
            </div>
        </div>
    </div>`,
};
